import { render } from "./fxxg.vue?vue&type=template&id=828159ee&scoped=true&ts=true"
import script from "./fxxg.vue?vue&type=script&lang=ts"
export * from "./fxxg.vue?vue&type=script&lang=ts"

import "./fxxg.vue?vue&type=style&index=0&id=828159ee&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828159ee"]])

export default __exports__